var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoundCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 11.9998C2 6.47691 6.47715 1.99976 12 1.99976C17.5228 1.99976 22 6.47691 22 11.9998C22 17.5226 17.5228 21.9998 12 21.9998C6.47715 21.9998 2 17.5226 2 11.9998Z",
    fill: "#DAE0F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.29289 8.29265C8.68342 7.90212 9.31658 7.90212 9.70711 8.29265L12 10.5855L14.2929 8.29265C14.6834 7.90212 15.3166 7.90212 15.7071 8.29265C16.0976 8.68317 16.0976 9.31634 15.7071 9.70686L13.4142 11.9998L15.7071 14.2926C16.0976 14.6832 16.0976 15.3163 15.7071 15.7069C15.3166 16.0974 14.6834 16.0974 14.2929 15.7069L12 13.414L9.70711 15.7069C9.31658 16.0974 8.68342 16.0974 8.29289 15.7069C7.90237 15.3163 7.90237 14.6832 8.29289 14.2926L10.5858 11.9998L8.29289 9.70686C7.90237 9.31634 7.90237 8.68317 8.29289 8.29265Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundCross);
export default __webpack_public_path__ + "static/media/round-cross.53c7b94a.svg";
export { ForwardRef as ReactComponent };